enum VaginalExperience {
    Spontaneous,
    Vacuum,
    Forceps,
    VaginalBirthAfterCaesarianSection,
    EpisiotomyOrLacerations,
    ObstetricalAnalSphincterInjuries
}

export { VaginalExperience };
